var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { Mention, Plugin } from 'shared/domains/pleditor@next';
import { CommentMentionConversion } from './CommentMentionConversion';
import { ItemRendererClassNamesManager } from './ItemRendererClassNamesManager';
import { excludeAnonymousUser, isCompanyUser, isCompanyUserWithAccess, isCompanyUserWithoutAccess, isExternalUser, isExternalUserId, sortAlphabetically, } from './utils';
import { UsersManagerRTC } from '../UsersManagerRTC';
export class UserMentionsRTC extends Plugin {
    constructor() {
        super(...arguments);
        this.classNamesManager = new ItemRendererClassNamesManager();
    }
    static get pluginName() {
        return 'UserMentionsRTC';
    }
    static get requires() {
        return ['UsersManagerRTC'];
    }
    init() {
        return __awaiter(this, void 0, void 0, function* () {
            this.addMentionConfig();
        });
    }
    addMentionConfig() {
        this.editor.config.set('comments', {
            editorConfig: {
                usersManager: this.editor.plugins.get(UsersManagerRTC),
                extraPlugins: [Mention, CommentMentionConversion],
                mention: {
                    feeds: [
                        {
                            marker: '@',
                            minimumCharacters: 0,
                            feed: this.getUsersFeed.bind(this),
                            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                            // @ts-ignore
                            itemRenderer: this.customItemRenderer.bind(this),
                        },
                    ],
                },
            },
        });
    }
    getUsersFeed(queryText) {
        return __awaiter(this, void 0, void 0, function* () {
            this.classNamesManager = new ItemRendererClassNamesManager();
            const usersManager = this.editor.plugins.get(UsersManagerRTC);
            const users = usersManager.getAllUsers();
            yield usersManager.getDocumentUsersWithAcls();
            const usersFeed = users
                .filter(excludeAnonymousUser)
                .filter((item) => item.name.toLowerCase().startsWith(queryText.toLowerCase()))
                .map((item) => ({
                id: `@${item.name}`,
                userId: item.id,
                name: item.name,
                actions: usersManager.getUserActions(item.id),
            }));
            const companyUsers = usersFeed.filter(isCompanyUser);
            const companyUsersWithAccess = companyUsers
                .filter(isCompanyUserWithAccess)
                .sort(sortAlphabetically);
            const companyUsersWithoutAccess = companyUsers
                .filter(isCompanyUserWithoutAccess)
                .sort(sortAlphabetically);
            const externalUsers = usersFeed.filter(isExternalUser).sort(sortAlphabetically);
            return [...companyUsersWithAccess, ...companyUsersWithoutAccess, ...externalUsers];
        });
    }
    customItemRenderer(item) {
        const { userId, name, actions } = item;
        const itemElement = document.createElement('div');
        const itemClassNames = this.classNamesManager.getItemClassNames(actions, isExternalUserId(userId));
        itemElement.classList.add(...itemClassNames);
        itemElement.id = `mention-list-item-id-${userId}`;
        itemElement.textContent = name;
        return itemElement;
    }
}
